import { render } from "./AppIcon.vue?vue&type=template&id=b5042192&scoped=true&lang=pug"
import script from "./AppIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=js"

import "./AppIcon.vue?vue&type=style&index=0&id=b5042192&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5042192"]])

export default __exports__